import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Item = styled.div`
  display: flex;
  gap: 4px;
`;

export const ItemText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  overflow: hidden;
`;
